import { render, staticRenderFns } from "./ServiceResource.vue?vue&type=template&id=4bdc7a8e&scoped=true&"
import script from "./ServiceResource.vue?vue&type=script&lang=js&"
export * from "./ServiceResource.vue?vue&type=script&lang=js&"
import style0 from "./ServiceResource.vue?vue&type=style&index=0&id=4bdc7a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc7a8e",
  null
  
)

export default component.exports